import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles/index';
import { Button, Card, CardContent, FormControl, Input, InputLabel, Typography } from '@material-ui/core';
import classNames from 'classnames';
import * as Actions from 'auth/store/actions';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import _ from 'lodash';
import Utils from '../../custom/utils';
import {API, BASE_URL, BROKER_BG, BROKER_LOGO} from "../../../config";
import {withContext} from "../../custom/StateProvider";

const investors = API.service('investors');

const styles = theme => ({
  root: {
    background: "url("+BROKER_BG+") no-repeat",
    backgroundSize: 'cover'
  },
  intro: {
    color: '#ffffff'
  },
  card: {
    width: '100%',
    maxWidth: 400
  }
});

class Login extends Component {
  state = {
    email: '',
    password: '',
    error: false,
    lat: '',
    lon: '',
    speed: '',
    heading: '',
    canSubmit:true,
    busy:false,
  };

  componentWillMount() {
    this.submit = this.submit.bind(this);
  }

  handleChange = (event) => {
    this.setState(_.set({ ...this.state }, event.target.name, event.target.type === 'checkbox' ? event.target.checked : event.target.value));
  };

  canBeSubmitted() {
    const { email, password } = this.state;
    return (
      email.length > 0 && password.length > 0
    );
  }

  submit(e) {
    e.preventDefault();

    const { email, password } = this.state;

    var controller = this;

    controller.setState({
      error: false,
      canSubmit:false,
      busy:true,
    })

    API.authenticate({
      strategy: 'local',
      _user_id: email,
      _password: password
    }).then(response => {
      investors.find({ query: { _user_id: email } }).then((u) => {
        u = u.data[0];
        var payload = {
          data: {
            data: {
              'displayName': u._firstname + ' ' + u._surname,
              'photoURL': 'assets/images/avatars/profile.jpg',
              'email': u._email,
              'ident': u._account,
              'id_number': u._id,
              'userRole': u._userRole,
              'affiliate': u._affiliate,
              settings: {}
            },
            role: JSON.parse(u._permissions),
            'userRole': u._userRole,
            affiliate: u._affiliate,
          }
        };

        let perms = u._permissions;

        if(Utils.isJSON(perms)){
          perms = JSON.parse(u._permissions);
        }

        controller.props.context.update({
          authenticated: true,
          username: u._email,
          displayName: u._firstname + ' ' + u._surname,
          displayRole: u._userRole,
          permissions: (Array.isArray(perms)) ? perms : ['none'],
        });

        controller.props.setUserData(payload.data);

        var loc = (Utils.isEmpty(u.default_access)) ? '/dashboard' : u.default_access;

        controller.props.history.push({
          pathname: loc,
          state: { redirectUrl: controller.props.location.pathname }
        });
      })

    }).catch((error) => {
      controller.setState({
        error: error.message,
        canSubmit:true,
        busy:false,
      })
    })
  }

  render() {
    const { classes } = this.props;
    const { email, password } = this.state;

    return (
      <div className={classNames(classes.root, "flex flex-col flex-auto flex-no-shrink items-center justify-center p-32")}>

        <div className="flex flex-col items-center justify-center w-full">

          <img className="m-16" style={{ width: '220px' }} src={BROKER_LOGO} alt="logo" />
          <Card className={classes.card}>

            <CardContent className="flex flex-col items-center justify-center p-32">

              <Typography variant="title" className="mt-16 mb-16">LOGIN TO YOUR ACCOUNT</Typography>

              {(this.state.error) &&
                <div
                  className="sm:w-320 bg-red-lightest border border-red-light text-red-dark p-12 mb-12 rounded relative text-center"
                  role="alert">
                  <span className="block sm:inline">{this.state.error}</span>
                </div>
              }

              <form name="loginForm" noValidate className="flex flex-col justify-center w-full" method={'POST'} onSubmit={this.submit}>

                <FormControl className="mb-16" fullWidth required>
                  <InputLabel>Email</InputLabel>
                  <Input
                    type="email"
                    name="email"
                    value={email}
                    onChange={this.handleChange}
                  />
                </FormControl>

                <FormControl className="mb-16" fullWidth required>
                  <InputLabel>Password</InputLabel>
                  <Input
                    type="password"
                    name="password"
                    value={password}
                    onChange={this.handleChange}
                  />
                </FormControl>

                <div className="flex items-center justify-between">

                  {/*<Link className="font-medium" to="/forgotpassword">
                    Forgot Password?
                        </Link>*/}
                </div>

                <a href={BASE_URL + '/forgotpassword'}>Forgot Password?</a>

                <Button type="submit"
                  variant="raised"
                  color="primary"
                  className="w-full mx-auto mt-16 normal-case"
                  aria-label="LOG IN"
                  value="legacy"
                  disabled={!this.state.canSubmit}
                >
                  {this.state.busy &&
                  <div className="spinner-wrapper">
                    <div className="spinner">
                      <div className="inner">
                        <div className="gap"></div>
                        <div className="left">
                          <div className="half-circle"></div>
                        </div>
                        <div className="right">
                          <div className="half-circle"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                  }
                  {!this.state.busy &&
                  <span>Login</span>
                  }
                                </Button>

              </form>
              <div className={classes.footText + ' mt-12'}>&copy; Copyright 2019 Y Effect Pty Ltd</div>
            </CardContent>
          </Card>
        </div>
      </div>
    );
  }

}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    setUserData: Actions.setUserData
  }, dispatch);
}

function mapStateToProps({ fuse, auth }) {
  return {
    login: auth.login,
    user: auth.user
  }
}

export default withContext(withStyles(styles, { withTheme: true })(connect(mapStateToProps, mapDispatchToProps)(Login)));
